<template>
  <div>
    <main class="main ">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <!-- <router-link  :key="index" v-for="(breadcrumb, index) in $store.state.breadcrumb"  tag="li" :to="breadcrumb.path"><a>{{breadcrumb.name}}</a></router-link> -->
            <li><router-link to="/index"><a href="/index">首頁</a></router-link></li>
            <li>鯨選課程</li>
          </ul>
        </div>
      </div>
      <div class="category">
        <div class="trigger">
          <div class="container">
            <!--此為目前選擇的分類名稱，行動版才會有-->
            全部課程
          </div>
        </div>
        <div class="container">
          <div class="content">
            <ul>
              <li :class="{ 'current': 0 === clickId }">
                <a href="javascript:void(0);"  @click="filterClass(0)">全部課程</a>
              </li>

              <li :class="{ 'current': categoriesData.id === clickId }" v-for="(categoriesData) in categoriesDatas" :key="categoriesData.id" >
                <a href="javascript:void(0);" @click="filterClass(categoriesData.id)">{{categoriesData.title}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="bodyContent">
        <div class="container">
          <!-- <section class="conditionSection">
              <fieldset>
                  <legend>排序：</legend>
                  <div class="inputText">
                      <select name="" id="">
                          <option selected="selected" value="%">依上架時間</option>
                          <option value="01">依更新時間</option>
                          <option value="02">依熱門排序</option>
                      </select>
                  </div>
              </fieldset>
          </section> -->
          <section class="normalList">
            <ul class="slick_list course_style2">
              <!-- <li>
                  <figure>
                      <div class="graphic"><img src="images/sample/course_1.jpg"></div>
                  </figure>
                  <figcaption>
                      <h3>寶寶怎麼養才好</h3>
                      <b>葉寶寶</b>
                  </figcaption>
                  <a href="course.html" class="fullLink" title="寶寶怎麼養才好">詳細內容</a>
              </li> -->
              <li v-for="(classDatas,$index) in paginationClassData" :key="classDatas.id"  @click="channelClickListener (classDatas, $index)"  >
                <figure>
                  <div class="graphic"><img v-bind:src="classDatas.imgCover"></div>
                </figure>
                <figcaption>
                  <h3>{{classDatas.title}}</h3>
                  <b>{{classDatas.author.title}}</b>
                </figcaption>
                <router-link v-bind:to="'/channel/'+classDatas.id" class="fullLink"></router-link>
                <!-- <a  class="fullLink" title="經理的面具：掌握管理的情境">詳細內容</a> -->
              </li>
            </ul>
          </section>

          <div class="pagiContainer">
            <v-pagination
              v-model="currentPage"
              :page-count="totalPages"
              :classes="bootstrapPaginationClasses">
            </v-pagination>
          </div>

        </div>
      </div>

    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import vPagination from 'vue-plain-pagination'

export default {
  components: { vPagination },

  name: 'async',
  metaInfo () {
    return {

      title: '鯨選課程 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '鯨選課程 | 一刻鯨選' },
        { property: 'og:site_name', content: '鯨選課程 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '提供豐富多元內容，精心打造，時刻陪伴！' }

      ]
    }
  },

  data () {
    return {
      clickId: 0,
      classData: [],
      initClassData: [], // 暫存初始值
      categoriesDatas: [], // 分類列表
      api_current_page: 1, // 抓取API頁數
      currentPage: 1, // 當前頁數
      totalPages: 2, // 總共頁數
      paginationClassData: [], // 分頁後資料
      allCount: 0,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      }

    }
  },
  beforeRouteLeave (to, from, next) {
    // 跳轉其他頁拿掉緩存
    if (to.path.indexOf('/channel/') >= 0) {
      this.$route.meta.keepAlive = true
    } else {
      this.$route.meta.keepAlive = false
    }
    next()
  },

  // watch: {
  //   '$route.params.id': (id) => {
  //     console.log('@@@@@@', id)
  //   }
  // },

  updated () {
    this.sortClass(this.classData, 'update')
  },
  created () {
    this.axios
      .get(this.$store.getters.baseURL + 'channels?per_page=1000')
      .then(response => {
        this.api_current_page = 1
        this.classData = response.data.data
        this.initClassData = response.data.data
        this.sortClass(this.classData, 'add')
      })
      .catch(error => console.log('log:' + error))

    // 抓取分類
    this.axios
      .get(this.$store.getters.baseURL + 'categories')
      .then(response => {
        this.categoriesDatas = response.data.data
      })
      .catch(error => console.log('log:' + error))
  },
  methods: {

    // goToCannelBy (id) {
    //   const path = '/channel/list' + id ? `/${id}` : ''
    //   this.$router.push({ path })
    // },
    channelClickListener (item, index) {
      // alert(item.id);
      const id = item.id
      // this.$router.push({ path: "/course" });
      // this.$store.commit('courseId', id)
      this.$router.push({ path: '/channel/' + id, params: { id } })
    },
    changePage (page) {
      this.$router.replace({ path: '/' + page })
    },

    // 篩選
    filterClass (id) {
      this.clickId = id
      let i = 0
      this.classData = []
      for (i; i < this.initClassData.length; i++) {
        if (this.initClassData[i].category_id === id) {
          this.classData.push(this.initClassData[i])
        }
      }
      if (id === 0) { // 全部課程
        $(this).parent().removeClass('current')
        this.classData = this.initClassData
      }
      this.sortClass(this.classData, 'add')
    },

    // 分頁
    sortClass (classData, type) {
      if (type === 'add') {
        this.paginationClassData = []
        let i = 0
        this.allCount = classData.length
        this.totalPages = Math.ceil(classData.length / 12)

        let size = classData.length
        if (classData.length > 12) {
          size = 12
        }
        for (i = 0; i < size; i++) {
          this.paginationClassData.push(classData[i])
        }
      } else {
        if (this.api_current_page !== this.currentPage) {
          this.paginationClassData = []
          this.allCount = classData.length

          let i = (this.currentPage - 1) * 12

          if (this.allCount > this.currentPage * 12) { // 最多12筆
            this.allCount = this.currentPage * 12
          }

          for (i; i < this.allCount; i++) {
            this.paginationClassData.push(classData[i])
          }

          this.api_current_page = this.currentPage
        }
      }
    }

  },
  mounted () {
    $('.category .trigger').click(function () {
      $('.category > .container').slideToggle()
      $(this).parent().toggleClass('active')
    })

    $('pagiContainer.first.paginate_button, pagiContainer.last.paginate_button').hide()
    $('body').removeClass('index')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/CourseList.vue